module.exports = __webpack_public_path__ + "assets/img/benefit-nxcash.ba5538c2.png";